import { render, staticRenderFns } from "./FixProductPrice.vue?vue&type=template&id=21814c87"
import script from "./FixProductPrice.vue?vue&type=script&lang=js"
export * from "./FixProductPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports